/* Coral Keepsake: tap-to-fill ready-made messages. Tapping one puts it in its box (the dedication box,
   or the box named by data-ckb-for on the group), where the customer can keep it or change it.
   The preview updates exactly as if they had typed it. */
(function(){
 'use strict';
 const boxFor=group=>{const root=group.closest('.ckb-preview');return root&&root.querySelector('[data-ckb="'+(group.dataset.ckbFor||'dedication')+'"]');};
 function sync(root){
  for(const group of root.querySelectorAll('.ckb-picks')){const box=boxFor(group);if(!box)continue;
   for(const b of group.querySelectorAll('[data-ckb-pick]'))b.setAttribute('aria-pressed',String(box.value.trim()===b.dataset.ckbPick));}
 }
 document.addEventListener('click',e=>{
  const b=e.target.closest&&e.target.closest('[data-ckb-pick]');if(!b)return;
  const group=b.closest('.ckb-picks'),box=group&&boxFor(group);if(!box)return;
  e.preventDefault();box.value=b.dataset.ckbPick;box.dispatchEvent(new Event('input',{bubbles:true}));sync(b.closest('.ckb-preview'));
 });
 document.addEventListener('input',e=>{const root=e.target.closest&&e.target.closest('.ckb-preview');if(root)sync(root);});
})();
